import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import Cookies from 'universal-cookie';
import { Link } from 'react-router-dom';

import HeaderText from '../../components/communal/HeaderText';
import InteractionTimeout from '../../components/communal/InteractionTimeout';
import SetTitle from '../../components/communal/SetTitle';

class ThankYou extends Component {
  constructor(props) {
    super(props);

    this.mainPageRef = React.createRef();
  }

  message() {
    var message = ""

    if (this.props.location.state.direction === "arriving") {
      message = JSON.parse(localStorage.getItem("location")).arrival_thank_you_message
    }
    else if (this.props.location.state.direction === "leaving") {
      message = JSON.parse(localStorage.getItem("location")).departure_thank_you_message
    }

    if (message === "") {
      message = "Thank you."
    }

    return message
  }

  renderStaffOnDuty() {
    const profile = this.props.location.state.profile
    const staff_on_duty = JSON.parse(localStorage.getItem("staff_on_duty"))

    if (profile === undefined || staff_on_duty === null) {
      return
    }

    if (!staff_on_duty.profile_ids.includes(profile.id)) {
      return
    }

    if (staff_on_duty.top_level.length === 0 && staff_on_duty.grouped_roles.length === 0) {
      return
    }

    const top_level_count = Math.min(staff_on_duty.top_level.length, 5)
    const grouped_roles_count = Math.min(staff_on_duty.grouped_roles.length, 4)

    return (
      <div className="background margin-bottom margin-top">
        <h3>Staff on Duty</h3>

        <div className="top-level" style={{gridTemplateColumns: `repeat(${top_level_count}, 1fr)`}}>
          {staff_on_duty.top_level.map((person, index) => (
            <div className="staff-display" key={index}>
              <div>{person.name}</div>
              <div>{person.job_title}</div>
              {this.renderPicture(person)}
            </div>
          ))}
        </div>

        <div className="grouped-roles margin-bottom" style={{gridTemplateColumns: `repeat(${grouped_roles_count}, 1fr)`}}>
          {staff_on_duty.grouped_roles.map((role, index) => {
            const role_staff_count = this.calculateRoleColumns(7)

            return (
              <div className="individual-role" style={{borderColor: role.color, backgroundColor: `${role.color}20`}} key={index}>
                <h4>{role.name}</h4>
                <div className="role-section" style={{gridTemplateColumns: `repeat(${role_staff_count}, 1fr)`}}>
                  {role.staff.map((person, index) => (
                    <div className="staff-display" key={index}>
                      {this.renderPicture(person)}
                      <div>{person.name}</div>
                    </div>
                  ))}
                </div>
              </div>
            )
          })}
        </div>
      </div>
    )
  }

  renderPicture(person) {
    if (person.picture !== null) {
      return <img alt={`${person.name}`} src={person.picture} />
    }
    else {
      return <img src={"../../default_avatar.jpg"} alt={`Default`}/>
    }
  }

  calculateRoleColumns(length) {
    const thresholds = [
      { max: 4, columns: 2 },
      { max: 9, columns: 3 },
      { max: 16, columns: 4 },
      { max: 25, columns: 5 },
    ];

    const matched = thresholds.find(({ max }) => max >= length)

    return matched ? matched.columns : 6
  }

  render() {
    const cookies = new Cookies()
    const token = cookies.get('device_token')

    if (token === undefined) {
      return <Redirect to="/setup/user"/>
    }

    if (this.props.location.state === undefined) {
      return <Redirect to="/404" />
    }

    return (
      <Link to={'/'} className="main-page" ref={this.mainPageRef}>
        <InteractionTimeout seconds={10} />

        <SetTitle title={"Thank You"} />
        <HeaderText hyperlink={false} />

        <div className="content">
          <div className="background">
            <div className="message">
              {this.message()}
            </div>
          </div>

          {this.renderStaffOnDuty()}
        </div>

        <div></div>
      </Link>
    );
  }

  componentDidMount() {
    // Revert any Feedback scrolling so the Thank You message displays first
    setTimeout(() => {
      if (this.mainPageRef.current) {
        this.mainPageRef.current.scrollIntoView({ block: "start", inline: "nearest", behavior: "instant" });
      }
    }, 0);
  }
}

export default ThankYou;
